export const iconFontAwesomeCharityHandHoldingDollar = (
	<i className="fa-solid fa-hand-holding-dollar"></i>
);
